export default __webpack_public_path__ + "static/media/Orange_Money.85e59eaa.jpg";